
import { Vue, Component } from 'vue-property-decorator'

@Component({})
export default class ChatSwitcher extends Vue {
  isImportant = false

  get driveUploaderSelected () {
    return this.$store.state.Chat.driveUploaderSelected
  }

  set driveUploaderSelected (driveUploaderSelected: boolean) {
    this.neutralizeSelection()
    this.$store.commit('setDriveUploaderSelected', driveUploaderSelected)
  }

  importantSelected () {
    this.neutralizeSelection()
    this.isImportant = true
    this.$emit('importantSelected', true)
  }

  get picked () {
    return this.$store.state.Chat.uploadType
  }

  challengePicked () {
    this.neutralizeSelection()
    this.$store.commit('updateUploadFiles', [])
    this.$store.commit('setPickedChallenge', 0)
    this.$store.commit('setUploadType', 'challenge')
  }

  neutralizeSelection () {
    this.isImportant = false
    this.$emit('deselectChallenge')
    this.$store.commit('setDriveUploaderSelected', false)
    this.$store.commit('setUploadType', '')
    this.$emit('importantSelected', false)
  }
}
